import { useContext, useState, useEffect, useMemo } from 'react';
import './pane-right-tasks-header.scss';
import './pane-right-task-description.scss';
import { CheckBox } from 'devextreme-react/check-box';
import { TextBox } from 'devextreme-react/text-box';
import { getTask, getFormURL } from '../common/api-requests';
import FileViewer from '../common/file-viewer';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import FormViewer from '../common/form-viewer';
import CommandViewer from '../common/command-viewer';
import { CompleteContext } from '../context/complete-context';
import { SocketContext } from '../context/socket-context';
import { AccountContext } from '../context/account-context';

function TaskItemDescription({ taskID }) {

    const [task, setTask] = useState(null);
    const [complete, setComplete] = useContext(CompleteContext);
    const [isComplete, setIsComplete] = useState(false);
    const [socket, setSocket] = useContext(SocketContext);
    const [account, setAccount] = useContext(AccountContext);

    const isFuture = (task) => {
        return task.dateFrom && new Date(task.dateFrom) > new Date();
    }

    useEffect(() => {
        if (!taskID) return;

        setIsComplete(false);

        getTask(taskID).then((data) => {
            setTask(data);

        });
    }, [taskID]);

    useEffect(() => {

        if (!taskID || !socket || socket.id !== taskID || socket.type !== 1) return;

        if (socket.action === 2){
            
            if (socket.recipientAccountID !== account.id || socket.isComplete){
                setTask(null);   
            }
            else{

                if (!isFuture(socket)){
                    setTask(socket);
                }
                else{
                    setTask(null);
                }
            }
        }
        else if (socket.action === 3)
           setTask(null);

    }, [socket]);


    useEffect(() => {
        if (!task || !complete || !complete.length)
            return;

        if (complete.some(item => item.id == task.id))
            setIsComplete(true);

    }, [task, complete]);



    if (!taskID || !task || isComplete)
        return <div className='task-item-description-container-empty'></div>;

    return (

        <div className="task-item-description-container">

            <div className="list-tasks-header" style={{ color: "#333" }}>
                <div className="task-item-template-header-item-color" style={{ backgroundColor: task.colorHex }} ></div>
                <div className="task-item-template-header-item-order">{task.orderNo ? task.orderNo : ""}</div>
                <div className="task-item-template-header-item">Опис завдання</div>
            </div>

            <div className="task-item-description-text" dangerouslySetInnerHTML={{ __html: task.textFormatted }}>
            </div>

            <br />

            <div className="task-item-description-files">
                <FileViewer files={task.files}></FileViewer>
            </div>
            <br />

            <div className={task.forms.length && task.commands.length ? "task-item-description-bottom" : "task-item-description-bottom-one"}>
                <FormViewer taskID={task.id} forms={task.forms}></FormViewer>
                <CommandViewer taskID={task.id} senderID={task.senderAccountID} commands={task.commands}></CommandViewer>
            </div>
        </div>
    );
};

export default TaskItemDescription;



